import React from 'react';
import Select from 'react-select';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';
import add from '../../img/add.svg';
import sortasc from '../../img/sort-asc.svg';
import sortdesc from '../../img/sort-desc.svg';

export default class BeneficiariesScreen extends React.Component {

    constructor(props) {
        super(props);

        let instituteid = null;
        let eventid = null;
        let selectedInstituteId = "";
        let sortField = null;
        let sortOrder = null;
        let pageCount = 0;

        const args = props.args === undefined ? {} : props.args;

        if (args.instituteid !== undefined) {
            instituteid = args.instituteid;
            selectedInstituteId = instituteid;
        }

        if (args.eventid !== undefined) {
            eventid = args.eventid;
        }

        if (args.pageCount !== undefined) {
            pageCount = args.pageCount;
        }

        if (args.sortField !== undefined) {
            sortField = args.sortField;
        }

        if (args.sortOrder !== undefined) {
            sortOrder = args.sortOrder;
        }

        this.state = {
            args: args,
            instituteOptions: [],
            pageLimit: 25,
            pageCount: pageCount,
            nameCriteria: "",
            prevNameCriteria: "",
            instituteId: instituteid,
            selectedInstituteId: selectedInstituteId,
            eventId: eventid,
            sortField: sortField,
            sortOrder: sortOrder,
            beneficiaries: []
        };

        this.nameSearch = this.nameSearch.bind(this);
        this.institutionChangeHandler = this.institutionChangeHandler.bind(this);
        this.nameCriteriaChangeHandler = this.nameCriteriaChangeHandler.bind(this);
        this.sortClicked = this.sortClicked.bind(this);
    }

    async componentDidMount() {
        this.getInstituteOptons();
        this.getDataWithCritera();
        setTimeout(this.nameSearch, 2000);
    }

    institutionChangeHandler(selectedOption) {
        const args = this.state.args;
        args.pageCount = 0;
        this.setState(
            {
                selectedInstituteId: selectedOption ? selectedOption.value : "",
                pageCount: 0,
                args: args
            },
            this.getDataWithCritera
        );
    }

    nameCriteriaChangeHandler(event) {
        this.setState({ nameCriteria: event.target.value });
    }

    getDataWithCritera() {
        const parameters = {};

        parameters.instituteid = this.state.selectedInstituteId;

        if (this.state.eventId) {
            parameters.eventid = this.state.eventId;
        }

        if (this.state.nameCriteria.length > 0) {
            parameters.name = this.state.nameCriteria;
        }

        parameters.limit = this.state.pageLimit;
        parameters.offset = this.state.pageLimit * this.state.pageCount;

        if (this.state.sortField) {
            parameters.orderby = this.state.sortField;
        }

        if (this.state.sortOrder) {
            parameters.sortorder = this.state.sortOrder;
        }

        BaseApi.get('/beneficiaries', {
            headers: {
                'Content-Type': 'application/json',
                'SESSIONID': sessionStorage.getItem("session")
            },
            params: parameters,
            withCredentials: true
        })
            .then(res => {
                this.setState({ beneficiaries: res.data });
            })
            .catch(error => console.log(error));
    }

    getInstituteOptons() {
        BaseApi.get("/institutions", {
            headers: {
                'Content-Type': 'application/json',
                'SESSIONID': sessionStorage.getItem("session")
            },
            params: { list: true },
            withCredentials: true
        })
            .then(res => {
                const instituteOptions = res.data.map(({ id, name }) => ({ value: id, label: name }));
                instituteOptions.push({ value: "", label: "Все" });
                this.setState({ instituteOptions: instituteOptions });
            })
            .catch(() => {});
    }

    nameSearch() {
        if (this.state.nameCriteria !== this.state.prevNameCriteria) {
            const args = this.state.args;
            args.pageCount = 0;
            this.setState(
                {
                    prevNameCriteria: this.state.nameCriteria,
                    pageCount: 0,
                    args: args
                },
                this.getDataWithCritera
            );
        }
        setTimeout(this.nameSearch, 2000);
    }

    nextPage() {
        const args = this.state.args;
        args.pageCount = this.state.pageCount + 1;
        this.setState(
            { pageCount: this.state.pageCount + 1, args: args },
            this.getDataWithCritera
        );
    }

    prevPage() {
        if (this.state.pageCount > 0) {
            const args = this.state.args;
            args.pageCount = this.state.pageCount - 1;
            this.setState(
                { pageCount: this.state.pageCount - 1, args: args },
                this.getDataWithCritera
            );
        }
    }

    sortClicked(event) {
        let currentField = this.state.sortField;
        let currentOrder = this.state.sortOrder;

        switch (event.currentTarget.id) {
            case "institutionCaption":
                if (currentField === "institution") {
                    currentOrder = currentOrder !== "desc" ? "desc" : "asc";
                } else {
                    currentField = "institution";
                    currentOrder = "asc";
                }
                break;
            case "nameCaption":
                if (currentField === "name") {
                    currentOrder = currentOrder !== "desc" ? "desc" : "asc";
                } else {
                    currentField = "name";
                    currentOrder = "asc";
                }
                break;
            case "birthdateCaption":
                if (currentField === "yearofbirth") {
                    currentOrder = currentOrder !== "desc" ? "desc" : "asc";
                } else {
                    currentField = "yearofbirth";
                    currentOrder = "asc";
                }
                break;
            default:
                break;
        }

        const args = this.state.args;
        args.pageCount = 0;
        args.sortField = currentField;
        args.sortOrder = currentOrder;

        this.setState(
            {
                sortField: currentField,
                sortOrder: currentOrder,
                pageCount: 0,
                args: args
            },
            this.getDataWithCritera
        );
    }

    openBeneficiar(id) {
        this.props.navigate("beneficiary", {
            caller: "beneficiaries",
            callargs: this.state.args,
            beneficiary: id
        });
    }

    isFieldSortedDesc(field) {
        return this.state.sortField === field && this.state.sortOrder === "desc";
    }

    isFieldSortedAsc(field) {
        return this.state.sortField === field && this.state.sortOrder !== "desc";
    }

    renderBeneficiarRow(beneficiar) {
        return (
            <tr
                key={beneficiar.id}
                className="table-row-clickable"
                onClick={() => this.openBeneficiar(beneficiar.id)}
            >
                {this.state.instituteId === null && (
                    <td style={{textAlign: 'left',  padding: '4px'}}>
                        {beneficiar.institution
                    }</td>
                )}
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {beneficiar.name}
                </td>
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {beneficiar.yearofbirth}
                </td>
            </tr>
        );
    }

    render() {
        const { instituteId, beneficiaries } = this.state;

        const colSpanBase = 2 + (instituteId === null ? 1 : 0); // учреждение + ФИО + год

        return (
            <div className="container">
                <ScreenCaption
                    goback={this.props.goback}
                    args={this.state.args}
                    caption={"Участники"}
                />

                {/* Фильтр + кнопка добавления + пагинация */}
                <div className="row mt-4 mb-3">
                    <div className="col-lg-6">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Фильтр</h6>

                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Имя</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        value={this.state.nameCriteria}
                                        onChange={this.nameCriteriaChangeHandler}
                                        placeholder="Введите ФИО или часть имени"
                                    />
                                </div>

                                {this.state.instituteId === null && (
                                    <div className="mb-1">
                                        <label htmlFor="institution" className="form-label">
                                            Учреждение
                                        </label>
                                        <Select
                                            options={this.state.instituteOptions}
                                            id="institution"
                                            onChange={this.institutionChangeHandler}
                                            placeholder="Все учреждения"
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6 d-flex flex-column align-items-end mt-3 mt-lg-0">
                        <div className="mb-2">
                            <button
                                type="button"
                                className="btn btn-primary d-flex align-items-center"
                                onClick={() => this.openBeneficiar("")}
                            >
                                Добавить участника
                            </button>
                        </div>

                        <div>
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm me-2"
                                onClick={() => this.prevPage()}
                                disabled={this.state.pageCount === 0}
                            >
                                Предыдущие
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => this.nextPage()}
                            >
                                Следующие
                            </button>
                        </div>
                    </div>
                </div>

                {/* Подсказка */}
                <p className="text-muted mb-2" style={{ fontSize: "0.9rem" }}>
                    Нажмите на строку, чтобы открыть карточку участника
                </p>

                {/* Таблица участников */}
                <div className="card shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0 align-middle">
                                <thead className="table-primary">
                                    <tr>
                                        {this.state.instituteId === null && (
                                            <th
                                                id="institutionCaption"
                                                onClick={this.sortClicked}
                                                style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                            >
                                                Учреждение{' '}
                                                {this.isFieldSortedDesc("institution") && (
                                                    <img src={sortdesc} height="14" alt="↓" />
                                                )}
                                                {this.isFieldSortedAsc("institution") && (
                                                    <img src={sortasc} height="14" alt="↑" />
                                                )}
                                            </th>
                                        )}
                                        <th
                                            id="nameCaption"
                                            onClick={this.sortClicked}
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                        >
                                            ФИО{' '}
                                            {this.isFieldSortedDesc("name") && (
                                                <img src={sortdesc} height="14" alt="↓" />
                                            )}
                                            {this.isFieldSortedAsc("name") && (
                                                <img src={sortasc} height="14" alt="↑" />
                                            )}
                                        </th>
                                        <th
                                            id="birthdateCaption"
                                            onClick={this.sortClicked}
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                        >
                                            Год рождения{' '}
                                            {this.isFieldSortedDesc("yearofbirth") && (
                                                <img src={sortdesc} height="14" alt="↓" />
                                            )}
                                            {this.isFieldSortedAsc("yearofbirth") && (
                                                <img src={sortasc} height="14" alt="↑" />
                                            )}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {beneficiaries.length === 0 && (
                                        <tr>
                                            <td
                                                colSpan={colSpanBase}
                                                className="text-center py-3 text-muted"
                                            >
                                                Участники не найдены по заданным критериям
                                            </td>
                                        </tr>
                                    )}
                                    {beneficiaries.map(b => this.renderBeneficiarRow(b))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ui/workspace-screens/beneficiaries.js